import React from "react";
import { connect } from "react-redux";
import Link from "redux-first-router-link";
import { utc, tz } from "moment-timezone";
import PropTypes from "prop-types";

import { Typography, AccordionSummary, AccordionDetails } from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { StyledAccordion, classes } from "./fullWidthStyles";

import Evidence from "views/Components/Finding/Evidence";

import "./Detail.sass";

const FindingDetailView = ({
  orgId,
  license,
  superadmin,
  srcCountry = [],
  summary = [],
  evidenceLoadStatus,
  matchId,
  relatedFindings = [],
  statusModified,
}) => {
  return (
    <StyledAccordion defaultExpanded square disableGutters>
      <AccordionSummary
        className={classes.accordionSummary}
        expandIcon={<KeyboardArrowDownIcon />}
      >
        <Typography className={classes.accordionTitle}>Details</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionPanel}>
        <div className={classes.findingsDetailContainer}>
          {statusModified && (
            <div className={classes.sectionContainer}>
              <span className={classes.sectionTitle}>Status Modified</span>
              {utc(statusModified).tz(tz.guess(true)).format("lll z")}
            </div>
          )}

          {summary && (
            <div className={classes.sectionContainer}>
              <span className={classes.sectionTitle}>Summary</span>
              {summary}
            </div>
          )}

          {srcCountry.length > 0 && (
            <div className={classes.sectionContainer}>
              <span className={classes.sectionTitle}>Source Countries</span>
              <ul>
                {srcCountry.map((s) => (
                  <li key={s}>{s}</li>
                ))}
              </ul>
            </div>
          )}

          {evidenceLoadStatus.data && evidenceLoadStatus.data.length > 0 && (
            <div className={classes.sectionContainer}>
              <span className={classes.sectionTitle}>Matched Evidence</span>
              <div className="evidence">
                <Evidence
                  initialData={evidenceLoadStatus.data}
                  orgId={orgId}
                  license={license}
                  matchId={matchId}
                  superadmin={superadmin}
                />
              </div>
            </div>
          )}

          {relatedFindings.length > 0 && (
            <div className={classes.sectionContainer}>
              <span className={classes.sectionTitle}>Related Findings</span>
              <div>
                {relatedFindings.map((finding) => (
                  <div key={finding.id} className="relatedFinding">
                    <Link to={finding.linkTo}>{finding.name}</Link>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </AccordionDetails>
    </StyledAccordion>
  );
};

FindingDetailView.propTypes = {
  orgId: PropTypes.string.isRequired,
  evidenceLoadStatus: PropTypes.shape({}),
  matchId: PropTypes.string.isRequired,
  superadmin: PropTypes.bool,
  srcCountry: PropTypes.arrayOf(PropTypes.string),
  summary: PropTypes.string,
  statusModified: PropTypes.string,
  relatedFindings: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      linkTo: PropTypes.shape({}),
    })
  ),
};

FindingDetailView.defaultProps = {
  superadmin: false,
  srcCountry: [],
  summary: "",
  statusModified: "",
  relatedFindings: [],
};

const mapStatetoProps = (state, { status, relatedFindings }) => ({
  orgId: state.location.payload.orgId,
  license: state.license,
  status: state.findings.get("constants").status.fromId(status),
  relatedFindings: state.findings
    .get("findings")
    .filter((i) => relatedFindings.indexOf(i.id) > -1)
    .map((finding) => ({
      name: finding.name,
      id: finding.id,
      linkTo: {
        type: "PAGE",
        payload: {
          orgId: finding.orgId,
          toplevel: "reporting",
          secondlevel: "findings",
          id1: finding.id,
        },
      },
    })),
});

export default connect(mapStatetoProps)(FindingDetailView);
